// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var TaxPolicyEditController = function($rootScope, $scope, $location, $routeParams, TaxPolicy, ProductInfo, CountryList,
   gettextCatalog, gettext, AccountSettings, EuropeanUnion, $http, DatepickerUtils) {
    let locale = gettextCatalog.currentLanguage.toUpperCase();
    var externalTaxCalculation = "ExternalTaxCalculation";
    
    $scope.countryNames = { };
    $scope.taxPolicy = { };
    
    $scope.accountSettings = AccountSettings.get({},
        function(data) {
            let vatId = data.CompanyInfo.VatId;
            $scope.vatCountryCode = vatId ? vatId.substring(0, 2) : null;
            afterAdd();
        });

    $scope.isReadonlyPolicy = function() {
        return $scope.taxPolicy.Name === 'Chargeback Fee';
    };
    
    $scope.getCountryName = function (code, locale) {
        if ($scope.countries && code) {
            var country = $scope.countries.find(function (country) { return country.TwoLetterCode === code });
            return (locale in country) ? country[locale] : country["EN"];
        }
    }

    var showErrorForCountry = function(country) {
        var locale = gettextCatalog.currentLanguage.toUpperCase();
        var countryName = $scope.getCountryName(country, locale);
        $scope.showErrorBox(gettextCatalog
            .getString(gettext("Something is wrong with tax records for {0}. Please check the rules"))
            .replace("{0}", countryName));
    };

    function addNames() {
        if (!$scope.taxPolicy.Entries)
            return;

        let locale = gettextCatalog.currentLanguage.toUpperCase();

        $scope.taxPolicy.Entries.forEach(function (entry) { setNames(entry, $scope.getCountryName(entry.Country, locale)) })
    }

    function setNames(entry, name) {
        entry.Name = name;

        if (entry.Country === "EU" || entry.Country === "XX")
            entry.FullName = entry.Name;
        else
            entry.FullName = entry.Name + " (" + entry.Country + ")";

        if (entry.ValidFrom)
            entry.FullName += " (" + entry.ValidFrom + ")";
    }

    function finish() {
        $location.path("/settings/taxpolicies");
    }

    var specialCountries = ["EU", "XX"];
    function isSpecial (entry) {
        return specialCountries.some(function (specialCountry) { return specialCountry === entry.Country });
    }

    var normalTaxCategories = ["Vat", "Untaxed", "ExternalTaxCalculation"];
    gettext("ExternalTaxCalculation");
    $scope.isNormalTaxDefinition = function(taxDefinition) {
        return normalTaxCategories.some(function (taxCategory) { return taxCategory === taxDefinition.PrimaryCategory });
    };
    
    $scope.isReverseChargeTaxDefinition = function(taxDefinition) {
        return taxDefinition.PrimaryCategory === "ReverseCharge";
    };

    var euCountries = EuropeanUnion.getEuCountries(Date.now());
    
    function getRegion (country) {        
        return country === 'EU' || euCountries.some(function (euCountry) { return euCountry === country }) ? 'EU' : 'XX';
    }

    $scope.newEntries = {};
    $scope.isCountryInRegion = {};
    $scope.regions = ['EU', 'XX'];
    $scope.regions.forEach(function (region) {
        $scope.newEntries[region] = {};
        $scope.isCountryInRegion[region] = function (country) { return getRegion(country) === region; };
    })
    $scope.isEntryInRegion = function (region) {
        return function (entry) { return getRegion(entry.Country) === region; };
    };

    function getEntriesByCountry (country) {
        return $scope.taxPolicy.Entries.filter(function(entry) { return entry.Country === country })
    }

    $scope.isCountryInEntries = function (country) {
        if ($scope.taxPolicy.Entries)
            return $scope.taxPolicy.Entries.some(function(entry) { return entry.Country === country })
    };

    $scope.canEditRate = function(entry) {
        return $scope.canEditEntries()
            && entry.TaxDefinitionId
            && !$scope.isUntaxed(entry.TaxDefinitionId);
    };

    $scope.isUntaxed = function (taxDefinitionId) {
        return $scope.isPrimaryCategory(taxDefinitionId, 'Untaxed');
    };

    $scope.isExternalTaxCalculation = function (taxDefinitionId) {
        return $scope.isPrimaryCategory(taxDefinitionId, 'ExternalTaxCalculation');
    };

    $scope.isPrimaryCategory = function (taxDefinitionId, category) {
        if ($scope.taxDefinitions && taxDefinitionId) {
            var taxDefinition = $scope.taxDefinitions.find(function (_) { return _.Id === taxDefinitionId });
            return taxDefinition.PrimaryCategory === category;
        }
        return false;
    };

    $scope.updateEntry = function(entry){
        if ($scope.isUntaxed(entry.TaxDefinitionId) || $scope.isExternalTaxCalculation(entry.TaxDefinitionId)) {
            entry.Rate = 0;
        }
    };

    $scope.canEditEntries = function() {
        return $scope.taxPolicy.Predefined !== "ChargebackFee";
    };

    $scope.canDelete = function(entry) {
        return $scope.canEditEntries() &&
            ((isSpecial(entry) === true  && entry.ValidFrom != null) ||
             (isSpecial(entry) === false && (entry.ValidFrom != null || getEntriesByCountry(entry.Country).length === 1)));
    };
    
    function compare(a, b) {
        if (a < b)
            return -1;
        if (a > b)
            return 1;
        return 0;
    }

    function sortEntries() {
        function compareEntries(a, b) {
            var bySpecial = compare(specialCountries.indexOf(a.Country), specialCountries.indexOf(b.Country));
            var byName = compare(a.Name, b.Name);
            var byValidFrom = compare(a.ValidFrom, b.ValidFrom);
            return bySpecial || byName || byValidFrom;
        }

        if ($scope.taxPolicy.Entries)
            $scope.taxPolicy.Entries.sort(compareEntries);
    }

    $scope.save = function () {
        if(!$scope.isAvalaraUsed())
            delete $scope.taxPolicy.ProductTaxCode;

        if ($routeParams.taxPolicyId)
            $scope.taxPolicy.$update({ taxPolicyId: $routeParams.taxPolicyId }, finish);
        else
            $scope.taxPolicy.$save({}, finish);
    };

    $scope.removeEntry = function (entry) {
        if (entry.ValidFrom == null) {
            if (getEntriesByCountry(entry.Country).length > 1) {
                showErrorForCountry(entry.Country);
                return;
            }
        }
        $scope.taxPolicy.Entries = $scope.taxPolicy.Entries.filter(function (_) { return _ !== entry });
    };

    $scope.addEntry = function (newEntry) {
        if (newEntry.Country.length !== 2)
            return;
        
        if ($scope.taxPolicy.Entries.some(function(entry) { return entry.Country === newEntry.Country && entry.ValidFrom === newEntry.ValidFrom; }))
            return;
        
        $scope.taxPolicy.Entries.push(newEntry);
        afterAdd();
    };

    function copy(object) {
        return Object.assign({}, object);
    }

    function afterAdd() {
        addNames();
        sortEntries();
        $scope.vatCountry = $scope.getCountryName($scope.vatCountryCode, locale);
    }
   
    let fillReverseChargeBlacklistAvailableCountries = function () {
       $http.get("/api/v1/taxPolicies/reverseChargeBlacklistAvailableCountries").then(function(response) {
           $scope.blacklistAvailableCountries = response.data
               .filter(function (country) { return $scope.taxPolicy.ReverseChargeCountryBlacklist.includes(country) === false; })
               .filter(function (country) { return country !== $scope.vatCountryCode; });
           $scope.blacklistAvailableCountries.sort(function (country1, country2) {
               return compare($scope.countryNames[country1], $scope.countryNames[country2]);
           });
       });
    }

    if ($routeParams.taxPolicyId) {
        TaxPolicy.get({ taxPolicyId: $routeParams.taxPolicyId }, function (data) {
            $scope.taxPolicy = data;
            afterAdd();
            
            $scope.taxPolicy.ReverseChargeCountryBlacklist.sort(function (country1, country2) {
                return compare($scope.countryNames[country1], $scope.countryNames[country2]);
            });
            $scope.taxPolicy.ReverseChargeTaxDefinitionId = $scope.taxPolicy.ReverseChargeTaxDefinitionId || null;
            fillReverseChargeBlacklistAvailableCountries();
        });
    } else {
        $scope.taxPolicy = new TaxPolicy();
        $scope.taxPolicy.Entries = [];
        $scope.addEntry({ Country: "DE" });
        $scope.addEntry({ Country: "DE", ValidFrom: "2020-07-01" });
        $scope.addEntry({ Country: "DE", ValidFrom: "2021-01-01" });
        $scope.addEntry({ Country: "EU" });
        $scope.addEntry({ Country: "EU", ValidFrom: "2020-07-01" });
        $scope.addEntry({ Country: "EU", ValidFrom: "2021-01-01" });
        $scope.addEntry({ Country: "XX" });
        $scope.taxPolicy.ReverseChargeTaxDefinitionId = null;
        $scope.taxPolicy.ReverseChargeCountryBlacklist = [ "GB", "XI" ];
        fillReverseChargeBlacklistAvailableCountries();
    }

    $scope.cancel = finish;
    
    function loadCountries() {
        CountryList.getCountries().then(function (response) {
            $scope.countries = response.data.slice();
            $scope.countries.push({ TwoLetterCode: "EU", DE: "Restliche EU", EN: "Remaining EU" });
            $scope.countries.push({ TwoLetterCode: "XX", DE: "Restliche Welt", EN: "Remaining world" });
            
            $scope.countryNames = $scope.countries.reduce(function(map, country) {
                map[country.TwoLetterCode] = $scope.getCountryName(country.TwoLetterCode);
                return map;
            }, { });
            
            afterAdd();
        },
            function () { });
    }

    $scope.$watch(function () { return gettextCatalog.currentLanguage; }, function (newValue, oldValue) {
        afterAdd();
    });

    $scope.productInfo = ProductInfo.get(function (productInfo) {
        var defaultEntry = {
            Id: null,
            InternalName: gettextCatalog.getString(gettext('Disabled')),
            PrimaryCategory: 'ReverseCharge'
        };
        $scope.taxDefinitions = [defaultEntry].concat(productInfo.TaxDefinitions);
        $scope.euTaxDefinitions =  $scope.taxDefinitions.filter(function (td) { return td.PrimaryCategory !== externalTaxCalculation; });
        $scope.taxDefinitionById = productInfo.TaxDefinitionById;
        $scope.avataxId = $scope.taxDefinitions.find(function(td) { return td.InternalName === 'AvaTax'; }).Id;
    });

    $scope.isAvalaraUsed = function() {
        if (!$scope.taxPolicy.Entries || !$scope.taxPolicy.Entries.length) {
            return;
        }

        return $scope.taxPolicy.Entries.some(function(entry) {
            return $scope.isAvalaraTaxDefinition(entry.TaxDefinitionId);
        })
    };

    $scope.isAvalaraTaxDefinition = function(taxDefinitionId) {
        return $scope.avataxId !== undefined && taxDefinitionId === $scope.avataxId;
    };
    
    $scope.addEntryClick = function (newEntry) {
        if (newEntry.Country) {
            let entries = getEntriesByCountry(newEntry.Country);
            if (entries.some(function () { return true }) === false || !newEntry.ValidFrom)
                newEntry.ValidFrom = undefined;

            let newEntryCopy = copy(newEntry);
            newEntryCopy.ValidFrom = DatepickerUtils.toShortBerlinDateString(newEntryCopy.ValidFrom);
            if (entries.some(function (entry) { return entry.ValidFrom === newEntryCopy.ValidFrom; })) {
                showErrorForCountry(newEntryCopy.Country);
                return;
            }

            $scope.addEntry(newEntryCopy);
            $scope.updateTaxPolicyEntry(newEntryCopy);
        }
    };

    loadCountries();

    $scope.currentTab = false;
    $scope.taxRatesTab = 'taxRates';
    $scope.reverseChargeTab = 'reverseCharge';
    $scope.changeTab = function(tabName) {
        $scope.currentTab = tabName;
    }
    
    $scope.addCountryToBlacklist = function (countryToAdd) {
        if (countryToAdd && $scope.taxPolicy.ReverseChargeCountryBlacklist.indexOf(countryToAdd) === -1) {
            $scope.taxPolicy.ReverseChargeCountryBlacklist.push(countryToAdd);
            $scope.blacklistAvailableCountries = $scope.blacklistAvailableCountries
                .filter(function (country) { return country !== countryToAdd; });
            $scope.newBlacklistCountry = undefined;
        }
    }

    $scope.removeCountryFromBlacklist = function (countryToRemove) {
        $scope.taxPolicy.ReverseChargeCountryBlacklist = $scope.taxPolicy.ReverseChargeCountryBlacklist
            .filter(function (country) { return country !== countryToRemove; });
        $scope.blacklistAvailableCountries.push(countryToRemove);
        $scope.blacklistAvailableCountries.sort(function (country1, country2) {
            return compare($scope.countryNames[country1], $scope.countryNames[country2]);
        });
    }

    $scope.formatCountryName = function (country) {
        return $scope.countryNames[country] + ' (' + country + ')';
    }
    
    $scope.updateTaxPolicyEntry = function (updatedEntry) {
        var toUpdate = $scope.taxPolicy.Entries.filter(function (entry) { return entry.Country === updatedEntry.Country; });
        var split = toUpdate.some(function (entry) { return entry.SplitOnTaxChange === true && entry.ValidFrom == null; });
        toUpdate.forEach(function (entry){
            entry.SplitOnTaxChange = split;
        })
    }
};
TaxPolicyEditController.$inject = ['$rootScope', '$scope', '$location', '$routeParams', 'TaxPolicy', 'ProductInfo',
    'CountryList', 'gettextCatalog', 'gettext', 'AccountSettings', 'EuropeanUnion', '$http', 'DatepickerUtils'];
